import { tsoPqTheme } from '@assets/style/customTsoPqtheme';
import { LinearProgress, LinearProgressProps } from '@mui/material';
import { styled } from '@mui/material/styles';

interface ProgressBarTsoPqProps extends Omit<LinearProgressProps, 'color'> {
  color?: string;
}

const StyledProgressBar = styled(LinearProgress)(() => ({
  backgroundColor: tsoPqTheme.palette.background.primary.color_primary_background_bg_prim,
  borderRadius: tsoPqTheme.shape.border_radius_tso_border_radius_2,
  '& .MuiLinearProgress-bar': {
    backgroundColor: tsoPqTheme.palette.background.primary.color_primary_background_bg_prim_enabled,
    borderRadius: tsoPqTheme.shape.border_radius_tso_border_radius_2,
  },
}));

const ProgressBarTsoPq = ({ color, ...props }: ProgressBarTsoPqProps) => {
  return <StyledProgressBar {...props} />;
};

export default ProgressBarTsoPq;
